/*
* CM
* SD-WAN
* 프로파일
* 경로 레이블
*
* @since 2022-10-21
* @author wj_tams_dev01
* */

import {CmApiPrefix} from '~/utils/restApi'

const urlPrefix = `${CmApiPrefix}/sdwan/profile/path-label`

export const state = () => ({
  pathLabelList: [] // 경로 레이블 리스트
})

export const mutations = {
  init (state) {
    state.pathLabelList = []
  },

  initPathLabelList (state, pathLabelList) {
    if (pathLabelList === undefined) {
      state.pathLabelList = []
    } else if (pathLabelList.length === undefined) { // 배열이 아니면
      state.pathLabelList.push(pathLabelList)
    } else {
      state.pathLabelList = pathLabelList
    }
  }
}

export const actions = {

  /* 경로레이블 전체 조회 */
  async getPathLabelList ({commit}, {loading = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/0`, {loading})
      if (code === 'ok') {
        commit('initPathLabelList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 경로레이블 추가 */
  async addPathLabel ({commit, state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post(`${urlPrefix}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 경로레이블 수정(편집) */
  async updatePathLabel ({state}, {param, loading = true, successAlert = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {
        code, result
      } = await this.$axios.$put(`${urlPrefix}/${param.sdwan_path_label_id}`, param, {loading, successAlert})
      if (code === 'ok') {
        res.result = result
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 경로레이블 삭제 */
  async deletePathLabel ({state}, {param} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$delete(`${urlPrefix}`, {data: param})
      if (code !== 'ok') {
        if (result.msg === undefined) {
          res = {code: 'nok', reason: '', result: result}
        } else {
          res = {code: 'nok', reason: result.msg, result: result}
        }
      } else {
        res = {code: 'ok', result: result}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 경로 레이블 전체 조회(DIA 타입 제외) - 터널 그룹 팝업에서 사용함 */
  async getDataPathLabelOverlay ({commit, state}, {param, loading = true} = {}) {
    let res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(`${urlPrefix}/overlay-only`, {loading})
      if (code === 'ok') {
        commit('initPathLabelList', result)
      } else {
        res = {code: 'nok', reason: result.msg}
      }
    } catch (e) {
      res = {code: 'nok', reason: e}
    }
    return res
  },

  /* 경로레이블 적용/취소 */
  async finalCommand ({state}, type) {
    let res = {code: 'ok'}
    const apiUri = `${urlPrefix}/${type}`,
      axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
    try {
      const result = await this.$axios.$put(apiUri, void 0, axiosConfig)
      res = result
    } catch (e) {
      res = {code: 'nok', result: {msg: e}}
    }
    return res
  }
}
